import { useFieldIsVisible } from './hooks/useFieldIsVisible'
import { useTexts } from './hooks/useTexts'

import { form } from '../../../formState'
import { FormData } from '../../../types'

import { BulkEligibility } from '../../primitives/BulkEligibility'

function isValidEligibility(eligibility: uui.domain.client.rm.Eligibility) {
  if (eligibility.type === 'on') {
    return eligibility.dates.length > 0
  }

  return true
}

export function Eligibility() {
  const texts = useTexts()
  const recurrenceSettingsValue = form.useFormField('recurrenceSettings').field.value
  const isVisible = useFieldIsVisible(recurrenceSettingsValue)

  form.useAddFieldValidation('eligibility', (field, _formApi) => {
    if (field.value) {
      const eligibility = field.value

      const valid = eligibility.status === 'exact' ? isValidEligibility(eligibility.value) : true

      return valid ? undefined : texts.invalidEligibilityNoDates
    }
  })

  if (!isVisible) {
    return null
  }

  return (
    <BulkEligibility<'eligibility', FormData>
      name="eligibility"
      bulkEligibilityFieldProps={{
        label: texts.eligibility,
        testId: 'eligibility',
      }}
    />
  )
}
